import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1080c5b1"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal fade",
  id: "modalConfirmAddUserToGroup",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = { class: "modal-title text-center fw-bold w-100" }
const _hoisted_6 = { class: "modal-body content mx-0 p-0" }
const _hoisted_7 = { class: "row py-2 py-lg-4 px-4 gx-0" }
const _hoisted_8 = { class: "fw-bold w-max-content col-4 col-form-label" }
const _hoisted_9 = { class: "row mx-0 px-lg-0 align-items-center col-8" }
const _hoisted_10 = { class: "px-4" }
const _hoisted_11 = { class: "bg-light py-3 ps-3 pe-2 mb-4" }
const _hoisted_12 = { class: "list-id" }
const _hoisted_13 = { class: "me-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode()
const _hoisted_16 = { class: "fw-bold text-center my-4" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode()
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_19 = { class: "row mx-0 px-0 d-flex justify-content-center flex-sm-row flex-column-reverse mb-4" }
const _hoisted_20 = { class: "col-lg-6 d-flex justify-content-lg-end justify-content-center" }
const _hoisted_21 = { class: "col-lg-6 d-flex justify-content-lg-start justify-content-center mb-4 mb-lg-0" }
const _hoisted_22 = {
  class: "modal fade",
  id: "modalSuccessAddUserToGroup",
  tabindex: "-1",
  "aria-labelledby": "successDeleteModal",
  "aria-hidden": "true"
}
const _hoisted_23 = { class: "modal-dialog" }
const _hoisted_24 = { class: "modal-content" }
const _hoisted_25 = { class: "modal-header" }
const _hoisted_26 = {
  class: "modal-title text-center fw-bold w-100",
  id: "SuccessDeleteModalHeader"
}
const _hoisted_27 = { class: "" }
const _hoisted_28 = { class: "text-center my-4" }
const _hoisted_29 = { class: "d-flex justify-content-center modal-footer" }

import { computed, onMounted, PropType, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { Modal } from 'bootstrap'
import Button from '@/components/button/index.vue'
import { translate } from '@/languages/i18n'
import UserAliasIcon from '@/components/user-alias-icon/index.vue'
import { CONVERSATIONS_STORE, GROUPS_STORE } from '@/store/constants'
import groupsServices from '@/services/groups.service'
import Loading from '@/components/loading/index.vue'
import { useStore } from 'vuex'


export default /*#__PURE__*/_defineComponent({
  props: {
  data: Array as PropType<Array<{ management_no: string; family_name: string; given_name: string; display_name: string; user_type: number }>>,
  setGroupData: Function as PropType<any>,
  groupData: Object as PropType<{ id: string; name: string }>,
  showDisplayName: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props

const route = useRoute()
const router = useRouter()
const store = useStore()
const modalCompleteAddToGroup = ref()
const addUserFailed = ref<boolean>(false)
const listGroups = computed(() => store.getters[GROUPS_STORE.GETTERS.ALL_GROUPS])



const loading = ref<boolean>(false)
const onSubmit = async (): Promise<void> => {
  const { data, groupData } = props
  const params = {
    create_by_admin: true,
    users_management_no: data?.map((item: any) => item.management_no),
  }
  try {
    loading.value = true
    const response = await groupsServices.adminAddUserToGroup(route.params?.id, groupData.id, params)
    if (response.status === 200) {
      addUserFailed.value = false
      store.dispatch(CONVERSATIONS_STORE.ACTIONS.CHECK_ALL_MANAGEMENT_NO, { typeData: 'employee', type: 'unCheckAll', data: [] })
      loading.value = false
      return
    } else {
      addUserFailed.value = true
    }
  } catch (error) {
    console.log(error)
  } finally {
    loading.value = false
    modalCompleteAddToGroup.value?.show()
  }
}

const statusMap: Record<string, string> = {
  leave: translate('SO10user30'),
  available: translate('OE12pause'),
}
const getItemDisplay = (item: any): string => {
  let displayName = `${item.family_name} ${item.given_name} ${statusMap[item.status] || ''}`
  if (props.showDisplayName) {
    displayName += ` (${item.display_name})`
  }
  return displayName
}

const reset = (): void => {
  props.setGroupData({ id: '', name: '' })
}

const transitToEditGroup = () => {
  router.push(`/community/communities/${route.params?.id}/admin/groups/${props.groupData.id}/edit`)
}

onMounted(() => {
  modalCompleteAddToGroup.value = new Modal(document.getElementById('modalSuccessAddUserToGroup'))
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h5", _hoisted_5, _toDisplayString(_unref(translate)('OE12addToGroup')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              onClick: reset,
              "aria-label": "Close"
            })
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(translate)('OE12GroupName')), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(__props.groupData?.name), 1)
            ]),
            _createElementVNode("form", {
              onSubmit: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("ul", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item, index) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: "mb-2 d-flex align-items-center",
                        key: index
                      }, [
                        _createVNode(UserAliasIcon, {
                          userType: item?.user_type
                        }, null, 8, ["userType"]),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(item?.management_no), 1),
                        _createElementVNode("span", null, _toDisplayString(getItemDisplay(item)), 1)
                      ]))
                    }), 128))
                  ])
                ]),
                _hoisted_14,
                _hoisted_15,
                _createElementVNode("p", _hoisted_16, _toDisplayString(_unref(translate)('updateQuestion')), 1),
                _hoisted_17,
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createVNode(Button, {
                      title: _unref(translate)('back'),
                      type: "secondary",
                      "data-bs-toggle": "modal",
                      "data-bs-target": "#modalAddUserToGroup"
                    }, null, 8, ["title"])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(Button, {
                      title: _unref(translate)('add'),
                      type: "secondary",
                      onClick: onSubmit,
                      "data-bs-dismiss": "modal"
                    }, null, 8, ["title"])
                  ])
                ])
              ])
            ], 32)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("h5", _hoisted_26, _toDisplayString(_unref(translate)('OE12addToGroup')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "btn-close",
              "data-bs-dismiss": "modal",
              onClick: reset,
              "aria-label": "Close"
            })
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("p", _hoisted_28, _toDisplayString(addUserFailed.value ? _unref(translate)('OE12addToGroupFailed') : _unref(translate)('OE12addToGroupSucceed', __props.groupData?.name)), 1)
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createVNode(Button, {
              title: _unref(translate)('close'),
              type: "secondary",
              onClick: reset,
              "data-bs-dismiss": "modal",
              className: "fw-bold"
            }, null, 8, ["title"]),
            _createVNode(Button, {
              title: _unref(translate)('OE12toEditGroup'),
              type: 'secondary',
              onClick: transitToEditGroup,
              "data-bs-dismiss": "modal",
              className: 'fw-bold'
            }, null, 8, ["title"])
          ])
        ])
      ])
    ]),
    _createVNode(Loading, { loading: loading.value }, null, 8, ["loading"])
  ], 64))
}
}

})